import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  parseDateTime,
  showCountOfImages,
  showSearchString,
  showVideoLength,
} from '../Partials/Helper';
import { requestGet } from '../../api/request';
import { EVENT_SEARCH_BY_GROUP, MAIN_URL } from '../../api/url';
import * as actions from '../../redux/actions';

const EvGrNews = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [searchParams, setSearchParams] = useSearchParams();

  const [event, setEvent] = useState({});
  const [currentPage, setCurrentPage] = useState(+searchParams.get('page') || undefined);
  const [searchText, setSearchText] = useState(searchParams.get('search') || '');
  const [selectedSearchByDate, setSelectedSearchByDate] = useState(searchParams.get('date') || null);

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(EVENT_SEARCH_BY_GROUP, {
      'event_type': 'news',
      'searchByDate': selectedSearchByDate,
      'page': currentPage,
      'searchText': searchText,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setEvent(response.data);
      setLoader(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 1) {
      searchParams.set('page', +pageNumber);
    } else {
      searchParams.delete('page');
      setCurrentPage(1);
    }
    setSearchParams(searchParams);
  };

  const handleSearchText = (e) => {
    const { target } = e;
    setCurrentPage(1);
    if (target.value !== null && target.value !== '') {
      searchParams.set('search', target.value);
      searchParams.delete('page');
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams);
  };

  const handleKeyPress = (e, value) => {
    if (e.key === 'Enter') {
      setSelectedSearchByDate(value);
    }
  };

  useEffect(() => {
    if (event.data) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  useEffect(() => {
    // Handle page url params;
    if (+searchParams.get('page') > 1) {
      setCurrentPage(+searchParams.get('page'));
    }
    // Handle search url params;
    if (searchParams.get('search')) {
      setSearchText(searchParams.get('search'));
    } else {
      setSearchText('');
    }
    // Handle date url params;
    if (searchParams.get('date')) {
      if (currentPage > 1) {
        // setCurrentPage(1);
      }
      setSelectedSearchByDate(searchParams.get('date'));
    } else {
      setSelectedSearchByDate(null);
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchText) {
      const delayDebounceFn = setTimeout(() => {
        setEvent({});
        getData();
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    } else {
      getData();
    }
  }, [currentPage, searchText, selectedSearchByDate, currentLanguage]);

  const showDatas = () => (
    event.data.map((data) => (
      data.assets.length === 0
      && data.news_flickr_image_relation.length === 0 ? (
        <div key={data.id} className="orders-item">
          <div className="orders-item">
            <a
              onClick={(e) => {
                e.preventDefault();
                if (
                  data.remote_url != null
                  && data.remote_url.includes('node')
                ) {
                  navigate(
                    `/event/${data.news_type_relation[0].news_type.name}/${data.remote_url}`,
                  );
                }
                if (
                  data.remote_url != null
                  && !data.remote_url.includes('node')
                ) {
                  navigate(data.remote_url);
                }
                if (data.remote_url === null) {
                  navigate(
                    `/event/${data.news_type_relation[0].news_type.name}/${data.id}`,
                  );
                }
              }}
              href={`/event/${data.news_type_relation[0].news_type.name}/${data.id}`}
              className="orders-link"
            >
              <span>{data.title}</span>
            </a>
            {
              searchText !== undefined
              && data.text
              && searchText.length > 1 ? (
                <div className="page-item__content">
                  {showSearchString(data, searchText)}
                </div>
                ) : null
            }
            <div className="orders-box">
              <div className="saidbar-item__box">
                <div className="saidbar-item__date">
                  <span>{parseDateTime(data.publish_date)}</span>
                  {data.city_relation.length > 0
                    ? data.city_relation.map((cityValue) => (
                      <span
                        key={cityValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_region/?q=${cityValue.city.name}`);
                        }}
                        style={{
                          cursor: 'pointer',
                          marginLeft: '4px',
                          marginBottom: '0px',
                          fontSize: '14px',
                        }}
                        className="main-tab__title"
                        onKeyDown={handleKeyPress}
                        role="button"
                        tabIndex="0"
                        aria-label="event"
                      >
                        {cityValue.city.name}
                      </span>
                    ))
                    : null}
                  {data.country_relation.length > 0
                    ? data.country_relation.map((countryValue) => (
                      <span key={countryValue.id}>
                        {' '}
                        {countryValue.country.name}
                      </span>
                    ))
                    : null}
                  {data.number ? (
                    <span>
                      №
                      {data.number}
                    </span>
                  ) : null}
                  <br />
                  {data.news_type_relation[0] ? (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        if (data.news_type_relation[0].news_type.type === 'documents') {
                          navigate(
                            `/event/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}`,
                          );
                        }
                        if (data.news_type_relation[0].news_type.name === 'in_trips') {
                          navigate(
                            `/event/${data.news_type_relation[0].news_type.name.replace(
                              'in_trips',
                              'domestic_trips',
                            )}`,
                          );
                        }
                        if (data.news_type_relation[0].news_type.name === 'out_trips') {
                          navigate(
                            `/event/${data.news_type_relation[0].news_type.name.replace(
                              'out_trips',
                              'foreign_trips',
                            )}`,
                          );
                        }
                        if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                          navigate(
                            '/government/government_sessions',
                          );
                        }
                        navigate(`/event/${data.news_type_relation[0].news_type.name}`);
                      }}
                      href=""
                      className="main-tab__title"
                      style={{ fontSize: '14px', marginBottom: '0em' }}
                    >
                      {' '}
                      {dictionary[data.news_type_relation[0].news_type.name]}
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        ) : (
          <div key={data.id} className="meetings-item">
            <div
              className="meetings-item__img"
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault();
                if (data.news_type_relation[0].news_type.type === 'news') {
                  navigate(
                    `/event/${data.news_type_relation[0].news_type.name}/${data.id}`,
                  );
                } else {
                  navigate(
                    `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}/${data.id}`,
                  );
                }
              }}
              onKeyDown={handleKeyPress}
              role="button"
              tabIndex="0"
            >
              <NewsImage news={data} />
            </div>
            <div className="meetings-item__content">
              {
                data.news_type_relation[0].news_type.type === 'news' ? (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/event/${data.news_type_relation[0].news_type.name}/${data.id}`,
                      );
                    }}
                    href={`/event/${data.news_type_relation[0].news_type.name}/${data.id}`}
                    className="meetings-item__list"
                  >
                    {data.title}
                  </a>
                ) : (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}/${data.id}`,
                      );
                    }}
                    href={`/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}/${data.id}`}
                    className="meetings-item__list"
                  >
                    {data.title}
                  </a>
                )
              }
              {
                searchText !== undefined
                && data.text
                && searchText.length > 1 ? (
                  <div className="page-item__content">
                    {showSearchString(data, searchText)}
                  </div>
                  ) : null
              }
              <div className="meetings-item__box">
                <div className="saidbar-item__box">
                  <div className="saidbar-item__date">
                    <span>{parseDateTime(data.publish_date)}</span>
                    {data.city_relation.length > 0
                      ? data.city_relation.map((cityValue) => (
                        <span
                          key={cityValue.id}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/search_by_region/?q=${cityValue.city.name}`);
                          }}
                          style={{
                            cursor: 'pointer',
                            marginLeft: '4px',
                            marginBottom: '0px',
                            fontSize: '14px',
                          }}
                          className="main-tab__title"
                          onKeyDown={handleKeyPress}
                          role="button"
                          tabIndex="0"
                          aria-label="event"
                        >
                          {cityValue.city.name}
                        </span>
                      ))
                      : null}

                    {data.news_type_relation[0] ? (
                      <>
                        <br />
                        {data.news_type_relation[0].news_type.type === 'news' ? (
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                                navigate(
                                  '/government/government_sessions',
                                );
                              } else {
                                navigate(`/event/${data.news_type_relation[0].news_type.name
                                  .replace('in_trips', 'domestic_trips')
                                  .replace('out_trips', 'foreign_trips')}`);
                              }
                            }}
                            href=""
                            className="main-tab__title"
                            style={{
                              fontSize: '14px',
                              marginBottom: '0em',
                            }}
                          >
                            {' '}
                            {
                              dictionary[
                                data.news_type_relation[0].news_type.name
                              ]
                            }
                          </a>
                        ) : null}
                        {data.news_type_relation[0].news_type.type
                        === 'internal_politics'
                        || data.news_type_relation[0].news_type.type
                        === 'international_structures'
                        || data.news_type_relation[0].news_type.type
                        === 'bilateral_relations' ? (
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}`,
                              );
                            }}
                            href=""
                            className="main-tab__title"
                            style={{
                              fontSize: '14px',
                              marginBottom: '0em',
                            }}
                          >
                            {' '}
                            {
                              dictionary[
                                data.news_type_relation[0].news_type.name
                              ]
                            }
                            ,
                            {' '}
                            {
                              dictionary[
                                data.news_type_relation[0].news_type.type
                              ]
                            }
                          </a>
                          ) : null}
                      </>
                    ) : null}
                  </div>

                  <div className="saidbar-item__right">
                    {
                  (data.news_flickr_image_relation
                    && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0)
                    || (data.assets
                    && data.assets.filter((t) => t.asset_type_id === 1).length > 0) ? (
                      <div className="saidbar-item__info">
                        <div className="saidbar-item__img">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="15"
                            height="12"
                            viewBox="0 0 15 12"
                          >
                            <path
                              className="st0"
                              d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                              fill="#5F5F5F"
                            />
                            <path
                              className="st0"
                              d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                              fill="#5F5F5F"
                            />
                            <path
                              className="st0"
                              d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,
                              1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                              fill="#5F5F5F"
                            />
                          </svg>
                        </div>
                        <div className="saidbar-item__count">
                          {showCountOfImages(data)}
                        </div>
                      </div>
                    ) : null
                    }
                    {
                    (data.assets
                      && data.assets.filter((t) => t.asset_type_id === 2).length > 0) ? (
                        <div className="saidbar-item__info">
                          <div className="saidbar-item__img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                            >
                              <path
                                className="st0"
                                d="M7.5,0C3.4,0,0,3.4,0,7.5C0,11.6,3.4,15,7.5,15S15,11.6,15,7.5C15,3.4,11.6,0,7.5,0z M7.5,13.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C13.5,10.8,10.8,13.5,7.5,13.5z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M5.2,11.3l6-3.8l-6-3.8V11.3z"
                                fill="#5F5F5F"
                              />
                            </svg>

                          </div>
                          <div className="saidbar-item__count">
                            {showVideoLength(data)}
                          </div>
                        </div>
                      ) : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
    ))
  );

  const NewsImage = ({ news }) => {
    if (
      (news.assets.length === 0
      && news.news_flickr_image_relation.length === 0)
      || (news.assets === null
      && news.news_flickr_image_relation == null)
      || (typeof news.assets === 'undefined'
      && typeof news.news_flickr_image_relation === 'undefined')
    ) {
      return null;
    }

    if (news.assets.length !== 0) {
      for (let i = 0; i < news.assets.length; i += 1) {
        if (news.assets[i].main === '1'
        && news.assets[i].asset_type_id === 1) {
          return (
            <img loading="lazy" src={MAIN_URL + news.assets[i].new_path.replace('/', '')} alt="" />
          );
        }
      }
    }

    if ((news.assets.length === 0
      && news.news_flickr_image_relation.length !== 0)
      || (news.assets.length !== 0
      && news.assets[0].asset_type_id !== 1
      && news.news_flickr_image_relation.length !== 0)) {
      return <img loading="lazy" src={news.news_flickr_image_relation[0].src} alt="" />;
    }
  };

  return (
    <>
      <div className="orders-search">
        <div className="search d-none d-lg-block">
          <input
            className="search__input"
            type="text"
            onChange={handleSearchText}
            placeholder={dictionary.search}
            value={searchText}
          />
          <button type="button" className="search-button">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1016_9838)">
                <path
                  d="M25.8333 23.3333H24.5167L24.05 22.8833C25.6833 20.9833 26.6667 18.5167 26.6667 15.8333C26.6667 9.85 21.8167 5 15.8333 5C9.85 5 5 9.85 5 15.8333C5 21.8167 9.85 26.6667 15.8333 26.6667C18.5167 26.6667 20.9833 25.6833 22.8833 24.05L23.3333 24.5167V25.8333L31.6667 34.15L34.15 31.6667L25.8333 23.3333ZM15.8333 23.3333C11.6833 23.3333 8.33333 19.9833 8.33333 15.8333C8.33333 11.6833 11.6833 8.33333 15.8333 8.33333C19.9833 8.33333 23.3333 11.6833 23.3333 15.8333C23.3333 19.9833 19.9833 23.3333 15.8333 23.3333Z"
                  fill="#333333"
                />
              </g>
              <defs>
                <clipPath id="clip0_1016_9838">
                  <rect
                    width="40"
                    height="40"
                    fill="white"
                    transform="translate(0 0.000244141)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      </div>
      <div className="tab-content" id="myTabContent">
        {loader === true ? (
          <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
            <div className="spinner-border text-success" role="status">
              <span className="sr-only" />
            </div>
          </div>
        ) : null}
        {event.data && event.data.length > 0 ? (
          <div
            className="tab-pane fade show active"
            id="#news_tab"
            role="tabpanel"
            aria-labelledby="#news_tab"
          >
            <div className="meetings-container">{showDatas()}</div>
            {event.last_page > 1
              ? (
                <Pagination
                  activePage={currentPage || 1}
                  totalItemsCount={event.data ? event.total : 0}
                  onChange={(pageNumber) => handlePageChange(pageNumber)}
                  pageRangeDisplayed={14}
                  itemclassName=""
                  linkclassName=""
                  firstPageText={dictionary.pagination_prev}
                  lastPageText={dictionary.pagination_last}
                  prevPageText={dictionary.pagination_first}
                  nextPageText={dictionary.pagination_next}
                  innerClass="paginations d-lg-flex flex-wrap"
                  hideDisabled={true}
                />
              ) : null }
          </div>
        ) : null}
      </div>
    </>
  );
};

export default EvGrNews;
